import { setResize } from "./set-resize";
import { updateSvgScale } from "./svg-scale";
import { config } from "../../config";

/** ブレークポイント跨ぎリロード後に先頭へスクロールするための sessionStorage キー（main.ts と共有） */
export const SESSION_KEY_SCROLL_TOP_AFTER_BREAKPOINT_RELOAD =
  "kakeru:scrollTopAfterBreakpointReload";

export const resize = (): void => {
  let resizeTimeout: NodeJS.Timeout;
  let breakpointCrossTimeout: ReturnType<typeof setTimeout>;
  let prevIsSp = document.documentElement.clientWidth < config.breakPoint;

  const reloadIfBreakpointCrossed = (): void => {
    const isSp = document.documentElement.clientWidth < config.breakPoint;
    if (isSp !== prevIsSp) {
      sessionStorage.setItem(SESSION_KEY_SCROLL_TOP_AFTER_BREAKPOINT_RELOAD, "1");
      location.reload();
      return;
    }
    prevIsSp = isSp;
  };

  const observer = new ResizeObserver(() => {
    // Update SVG scale immediately
    updateSvgScale();
    console.log("updateSvgScale");

    // Keep the delayed setResize for other functionality
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      setResize();
    }, 2000);
  });

  observer.observe(document.body);

  window.addEventListener("resize", () => {
    clearTimeout(breakpointCrossTimeout);
    breakpointCrossTimeout = setTimeout(reloadIfBreakpointCrossed, 150);
  });

  window.addEventListener("orientationchange", () => {
    updateSvgScale();
    setResize();
    requestAnimationFrame(() => {
      setTimeout(reloadIfBreakpointCrossed, 100);
    });
  });
};
